import { render, staticRenderFns } from "./index.vue?vue&type=template&id=05b5852a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=05b5852a&prod&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=05b5852a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b5852a",
  null
  
)

export default component.exports